<template>
  <div class="container">
    <h1 class="success-title">Ваша подписка успешно оплачена!</h1>
    <div class="success-subtitle">Какие дальнейшие шаги?</div>

    <div class="step">
      <p>1. Скачайте приложение MyVPN для Android</p>
      <button class="btn btn-download" @click="goToGooglePlay">
        Скачать приложение MyVPN
      </button>
    </div>

    <div class="step">
      <p>2. Активируйте подписку, нажав на кнопку ниже</p>
      <button class="btn btn-activate" @click="openDeeplink">
        Активировать подписку
      </button>
    </div>
  </div>
</template>

<script setup>
import { config } from '@/config';
import { getPlayStoreUrl } from '@/utils/playStoreUrl.js';
import { trackGooglePlayGoal } from '@/utils/trackGooglePlayGoal.js';
import { getStorage } from '@/utils/storage';
import { analytics } from '@/firebase.js';
import { logEvent } from 'firebase/analytics';

const goToGooglePlay = () => {
  trackGooglePlayGoal();
  window.location.href = getPlayStoreUrl();
};

async function openDeeplink() {
  const { token } = await getStorage(['token']);
  const { uid } = await getStorage(['user_id']);
  if (!token) return { success: false };

  ym(config.yandexMetrikaId, 'reachGoal', 'activate');
  logEvent(analytics, 'activate', { uid: uid });

  const url = `myvpn://open?token=${token}`;
  window.open(url, '_blank');
  return { success: true };
}
</script>

<style scoped>

/* Сброс */
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  background: #F5F8FF;
  color: #1B1B27;
  min-height: 100vh;
}

.container {
  max-width: 360px;
  margin: 0 auto;
  padding: 24px 16px;
}

/* Заголовки */
.success-title {
  font-size: 30px;
  font-weight: 500;
  text-align: center;
  margin-bottom: 8px;
}

.success-subtitle {
  font-size: 20px;
  font-weight: 400;
  text-align: center;
  margin-bottom: 24px;
  color: #5A5F66;
}

/* Шаги */
.step {
  background: #FFFFFF;
  border-radius: 16px;
  padding: 20px;
  margin-bottom: 16px;
}

.step p {
  font-size: 18px;
  margin-bottom: 12px;
}

/* Кнопки */
.btn {
  display: block;
  width: 100%;
  height: 48px;
  border: none;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  font-family: 'Play', sans-serif;
  background: #3B82F4;
  color: #FFFFFF;
  margin-bottom: 12px;
}

.btn-activate {
  margin-bottom: 0;
}
</style>
